import React, { useRef, useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { MdOutlineCategory } from 'react-icons/md';
import config from '../../../config';

const ImageWithFallback = ({ src, alt }) => {
    const [hasError, setHasError] = useState(false);
    if (hasError || !src) {
        return (
            <div
                className="default-logo-placeholder"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    color: '#9ca3af'
                }}
            >
                <MdOutlineCategory size={26} />
            </div>
        );
    }
    return <img src={src} alt={alt} onError={() => setHasError(true)} draggable="false" />;
};

const ShopGroups = ({
    groupsList,
    isGroupsFinished,
    selectedGroupId,
    onSelectGroup,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onMouseMove
}) => {
    const groupsScrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const checkScroll = () => {
        if (groupsScrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = groupsScrollRef.current;
            const absScrollLeft = Math.abs(scrollLeft);
            setCanScrollRight(absScrollLeft > 1);
            setCanScrollLeft(absScrollLeft + clientWidth < scrollWidth - 1);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(checkScroll, 100);
        window.addEventListener('resize', checkScroll);
        return () => {
            window.removeEventListener('resize', checkScroll);
            clearTimeout(timeoutId);
        };
    }, [selectedGroupId, groupsList, isGroupsFinished]);

    const scrollGroups = (direction) => {
        if (groupsScrollRef.current) {
            const scrollAmount = direction === 'left' ? -150 : 150;
            groupsScrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    return (
        <div className="groups">
            {canScrollLeft && (
                <div className="scroll-indicator left" onClick={() => scrollGroups('left')}>
                    <FaChevronLeft size="18px" />
                </div>
            )}

            {canScrollRight && (
                <div className="scroll-indicator right" onClick={() => scrollGroups('right')}>
                    <FaChevronRight size="18px" />
                </div>
            )}

            <div
                className="groups-wrraper custom-scroll-area"
                ref={groupsScrollRef}
                onScroll={checkScroll}
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}
            >
                {!isGroupsFinished ? (
                    [1, 2, 3, 4, 5].map((n) => (
                        <div className="group" key={n}>
                            <div className="logo skeleton-shimmer skeleton-logo" />
                            <div className="title skeleton-shimmer skeleton-title" />
                        </div>
                    ))
                ) : (
                    groupsList.map((group) => {
                        const isSelected = selectedGroupId === group.id;
                        return (
                            <div
                                className={`group ${isSelected ? 'selected-group' : ''}`}
                                key={group.id}
                                onClick={() => onSelectGroup(group.id)}
                            >
                                <div className="logo">
                                    <ImageWithFallback
                                        src={group.image_path ? `${config.api.imageURL}/${group.image_path}` : null}
                                        alt={group.title}
                                    />
                                </div>
                                <div className="title">
                                    <span
                                        style={{
                                            fontWeight: isSelected ? 'bold' : 'normal',
                                            color: isSelected ? '#5693f5' : 'inherit'
                                        }}
                                    >
                                        {group.title}
                                    </span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default React.memo(ShopGroups);
